import { Flex, TextV2 } from '@withjoy/joykit';
import { ReactNode } from 'react';
import React from 'react';

type ScheduleSectionProps = {
  children?: ReactNode;
  icon?: ReactNode;
  title?: string;
  padding?: string | number;
};

export const ScheduleSection = (props: ScheduleSectionProps) => {
  const { icon, title, children, padding } = props;

  return (
    <Flex
      gap="16px"
      flexDirection="column"
    >
      <Flex gap="16px">
        {icon && icon}
        {title && <TextV2 typographyVariant="hed4">{title}</TextV2>}
      </Flex>
      <Flex
        flexDirection="column"
        gap="8px"
        paddingLeft={padding ?? 0}
      >
        {children}
      </Flex>
    </Flex>
  );
};
